var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)

var cookie = require('js-cookie')

module.exports = function (el) {
  var $el = $(el)

  var freq = $el.data('fancybox-frequency')

  var link = $el.data('fancybox-link')

  var target = $el.data('fancybox-link-new-window')

  if (freq === 'default') {
    // Display once
    if (cookie.get('STYXKEY_visited') !== 'true') {
      setTimeout(function () {
        $el.fancybox({
          padding: 0,
          beforeLoad: function () {
            this.width = parseInt(this.element.data('fancybox-width'))
            this.height = parseInt(this.element.data('fancybox-height'))
          }
        }).trigger('click')
      }, 500)
      cookie.set('STYXKEY_visited', 'true', { expires: 1 })
    } else {
      return false
    }
  } else {
    // Default state
    $el.fancybox({
      padding: 0,
      beforeLoad: function () {
        this.width = parseInt(this.element.data('fancybox-width'))
        this.height = parseInt(this.element.data('fancybox-height'))
      }
    }).trigger('click')
  }

  if (link) {
    $el.find('img').on('click', function (e) {
      e.preventDefault()
      if (target) {
        // Open in new window
        window.open(link)
        return false
      } else {
        // Redirect
        window.location.href = link
      }
      cookie.set('STYXKEY_visited', 'true', { expires: 1 })
    })
  }
}
